// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.income-wizard-shell {
  margin: -1px;
  /* align with modal chrome */
}
.income-wizard-modal-header {
  background: linear-gradient(90deg, #1a2744 0%, #243356 100%);
  color: #fff;
  border-bottom: none;
  padding: 0.85rem 1.25rem;
}
.income-wizard-modal-header .modal-title {
  color: #fff;
  font-weight: 600;
  font-size: 1.05rem;
  letter-spacing: 0.02em;
}
.income-wizard-modal-header .close {
  opacity: 0.9;
  text-shadow: none;
  font-size: 1.5rem;
  font-weight: 300;
  line-height: 1;
}
.income-wizard-modal-header .close:hover {
  opacity: 1;
}
.income-wizard-modal-body {
  background: #f6f7fb;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.income-wizard-body {
  min-height: 6rem;
}
.income-wizard-modal-footer {
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding: 0.85rem 1.25rem;
}
.income-wizard-footer-btn {
  border-radius: 999px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-weight: 500;
}
.wo-finalizing-spinner {
  position: relative;
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
}
.wo-spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #005ff0;
  animation: wo-spin 1.2s linear infinite;
}
.wo-ring-2 {
  inset: 6px;
  border-top-color: #16a34a;
  animation-duration: 0.9s;
  animation-direction: reverse;
}
.wo-ring-3 {
  inset: 12px;
  border-top-color: #5d4d80;
  animation-duration: 1.5s;
}
@keyframes wo-spin {
  to {
    transform: rotate(360deg);
  }
}
.wo-finalizing-text {
  font-size: 0.92rem;
  font-weight: 600;
  color: #171717;
  text-align: center;
}
.wo-ellipsis::after {
  content: '';
  animation: wo-dots 1.4s steps(4, end) infinite;
}
@keyframes wo-dots {
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
  100% {
    content: '';
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/income-wizard.component.less"],"names":[],"mappings":"AACA;EACE,YAAA;EAAA,4BAA4B;AAC9B;AAEA;EACE,4DAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;AAAF;AAJA;EAOI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAAJ;AAVA;EAcI,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAEI;EACE,UAAA;AAAN;AAKA;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;AAHF;AAMA;EACE,gBAAA;AAJF;AAOA;EACE,gBAAA;EACA,yCAAA;EACA,wBAAA;AALF;AAQA;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AANF;AAUA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AARF;AAWA;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uCAAA;AATF;AAYA;EACE,UAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;AAVF;AAaA;EACE,WAAA;EACA,yBAAA;EACA,wBAAA;AAXF;AAcA;EACE;IAAK,yBAAA;EAXL;AACF;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAXF;AAcA;EACE,WAAA;EACA,8CAAA;AAZF;AAeA;EACE;IAAK,WAAA;EAZL;EAaA;IAAM,YAAA;EAVN;EAWA;IAAM,aAAA;EARN;EASA;IAAM,cAAA;EANN;EAOA;IAAO,WAAA;EAJP;AACF","sourcesContent":["// Shell wraps modal header/body/footer opened via NgbModal for consistent styling.\n.income-wizard-shell {\n  margin: -1px; /* align with modal chrome */\n}\n\n.income-wizard-modal-header {\n  background: linear-gradient(90deg, #1a2744 0%, #243356 100%);\n  color: #fff;\n  border-bottom: none;\n  padding: 0.85rem 1.25rem;\n\n  .modal-title {\n    color: #fff;\n    font-weight: 600;\n    font-size: 1.05rem;\n    letter-spacing: 0.02em;\n  }\n\n  .close {\n    opacity: 0.9;\n    text-shadow: none;\n    font-size: 1.5rem;\n    font-weight: 300;\n    line-height: 1;\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.income-wizard-modal-body {\n  background: #f6f7fb;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.income-wizard-body {\n  min-height: 6rem;\n}\n\n.income-wizard-modal-footer {\n  background: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  padding: 0.85rem 1.25rem;\n}\n\n.income-wizard-footer-btn {\n  border-radius: 999px;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  font-weight: 500;\n}\n\n// ── Shared loading spinner ──\n.wo-finalizing-spinner {\n  position: relative;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 20px;\n}\n\n.wo-spinner-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #005ff0;\n  animation: wo-spin 1.2s linear infinite;\n}\n\n.wo-ring-2 {\n  inset: 6px;\n  border-top-color: #16a34a;\n  animation-duration: 0.9s;\n  animation-direction: reverse;\n}\n\n.wo-ring-3 {\n  inset: 12px;\n  border-top-color: #5d4d80;\n  animation-duration: 1.5s;\n}\n\n@keyframes wo-spin {\n  to { transform: rotate(360deg); }\n}\n\n.wo-finalizing-text {\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: #171717;\n  text-align: center;\n}\n\n.wo-ellipsis::after {\n  content: '';\n  animation: wo-dots 1.4s steps(4, end) infinite;\n}\n\n@keyframes wo-dots {\n  0% { content: ''; }\n  25% { content: '.'; }\n  50% { content: '..'; }\n  75% { content: '...'; }\n  100% { content: ''; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
